import { useState } from 'react';
import { faqItems } from '@/mocks/seoData';

const siteUrl = (import.meta.env as Record<string, string>).VITE_SITE_URL || 'https://basetaosheet.monster';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              Frequently Asked Questions
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              Everything you need to know about BaseTao Spreadsheet
            </p>
          </div>

          <div className="space-y-3">
            {faqItems.map((item, idx) => (
              <div
                key={idx}
                className="rounded-2xl border border-background-200/70 bg-background-100 overflow-hidden transition-all duration-200"
              >
                <button
                  onClick={() => toggleFAQ(idx)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                >
                  <h4 className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                    {item.question}
                  </h4>
                  <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${openIndex === idx ? 'rotate-180' : ''}`}>
                    <i className="ri-arrow-down-s-line text-foreground-500"></i>
                  </div>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-200 ${
                    openIndex === idx ? 'max-h-96 px-5 pb-4' : 'max-h-0'
                  }`}
                >
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}